import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { youtubeCuepointsMessages } from '../messages/youtube-cuepoints-messages';
import { InsertCuepointDialog } from './InsertCuepointDialog';

interface InsertCuepointButtonProps {
  stationId: string;
  listId: string;
}

/**
 * Toolbar action to open the manual cuepoint insert dialog (AOD rules create-button style).
 */
export function InsertCuepointButton({ stationId, listId }: InsertCuepointButtonProps) {
  const { $t } = useIntl();
  const [open, setOpen] = useState(false);

  return (
    <Box display="flex">
      <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
        {$t(youtubeCuepointsMessages.insertButton)}
      </Button>
      <InsertCuepointDialog
        open={open}
        onClose={() => setOpen(false)}
        stationId={stationId}
        listId={listId}
      />
    </Box>
  );
}
